import React, { useEffect, useRef, useState } from "react";
import ModalComponent from "@/components/modal";
import { useDispatch } from "react-redux";
import ReactPlayer from "react-player";
import { setModalOpen } from "@/reducers/commonSlice";

const VideoPlayer = ({ isOpen, url }) => {
  const [isVideoPlaying, setIsVideoPlaying] = useState(isOpen ?? false);
  const dispatch = useDispatch();
  const playerRef = useRef(null);

  const handleModalClose = () => {
    // Dispatch an action to close the modal
    dispatch(setModalOpen(false));
  };

  useEffect(() => {
    if (isOpen) {
      setIsVideoPlaying(true);
    } else {
      setIsVideoPlaying(false);
    }
  }, [isOpen]);

  return (
    <ModalComponent isOpen={isVideoPlaying} width={600} closeIcon onCancelClick={handleModalClose}>
      <ReactPlayer
        ref={playerRef}
        className="videoFrame"
        width="100%"
        url={url}
        playing={isOpen}
        controls
        config={{
          file: {
            attributes: {
              controlsList: "nodownload",
              onContextMenu: (e) => e.preventDefault(),
            },
          },
        }}
      />
    </ModalComponent>
  );
};

export default VideoPlayer;
